// Mapping des clés CATEGORY_STRUCTURE vers des labels lisibles en français
// Utilisé par CategorySelector et CategorySearchSelector

const SPECIAL_LABELS: Record<string, string> = {
  // Catégories principales
  clothing: 'Vêtements',
  shoes: 'Chaussures',
  bags: 'Sacs',
  accessories: 'Accessoires',
  home: 'Maison',
  books: 'Livres',
  crafts: 'Loisirs créatifs',
  handmade: 'Fait main',
  custom: 'Personnalisé',
  toys: 'Jeux & jouets',
  // Groupes
  hauts: 'Hauts',
  pulls: 'Pulls & Gilets',
  robes: 'Robes',
  jupes: 'Jupes',
  pantalons: 'Pantalons',
  shorts: 'Shorts',
  combinaisons: 'Combinaisons',
  manteaux: 'Manteaux & Vestes',
  lingerie: 'Lingerie',
  maillots: 'Maillots de bain',
  sport: 'Sport',
  maternite: 'Maternité',
  ensembles: 'Ensembles',
  baskets: 'Baskets',
  talons: 'Talons',
  bottes: 'Bottes & Bottines',
  plates: 'Chaussures plates',
  mules: 'Mules',
  ville: 'Chaussures de ville',
  'sacs-main': 'Sacs à main',
  bandouliere: 'Bandoulière',
  pochettes: 'Pochettes',
  'sacs-dos': 'Sacs à dos',
  voyage: 'Voyage',
  maroquinerie: 'Maroquinerie',
  bijoux: 'Bijoux',
  echarpes: 'Écharpes & Foulards',
  ceintures: 'Ceintures',
  chapeaux: 'Chapeaux',
  lunettes: 'Lunettes',
  gants: 'Gants',
  montres: 'Montres',
  costumes: 'Costumes',
  'sous-vetements': 'Sous-vêtements',
  'tenues-religieuses': 'Tenues religieuses',
  'tenues-ceremonie-monde': 'Tenues du monde',
  pyjamas: 'Pyjamas',
  bodies: 'Bodies',
  bas: 'Bas',
  sommeil: 'Sommeil',
  bavoirs: 'Bavoirs',
  textiles: 'Textiles',
  decoration: 'Décoration',
  linge: 'Linge de maison',
  vaisselle: 'Vaisselle',
  rangement: 'Rangement',
  papeterie: 'Papeterie',
  jardin: 'Jardin',
  luminaires: 'Luminaires',
  romans: 'Romans',
  'bien-etre': 'Bien-être',
  art: 'Art & Design',
  cuisine: 'Cuisine',
  jeunesse: 'Jeunesse',
  bd: 'BD & Manga',
  scolaire: 'Scolaire',
  pratique: 'Pratique',
  biographie: 'Biographie',
  danse: 'Danse',
  deguisements: 'Déguisements',
  ballerines: 'Ballerines',
  sandales: 'Sandales',
  chaussons: 'Chaussons',
  sacs: 'Sacs',
  cheveux: 'Cheveux',
  hiver: 'Hiver',
  autres: 'Autres',
  sacoches: 'Sacoches',
  business: 'Business',
  cravates: 'Cravates',
  chaussures: 'Chaussures',

  // Items courants
  tshirt: 'T-shirt',
  'tshirt-bebe': 'T-shirt bébé',
  'tshirt-sport': 'T-shirt sport',
  'crop-top': 'Crop top',
  hoodie: 'Hoodie',
  sweat: 'Sweat',
  polo: 'Polo',
  chemise: 'Chemise',
  chemisier: 'Chemisier',
  blouse: 'Blouse',
  body: 'Body',
  bustier: 'Bustier',
  top: 'Top',
  pull: 'Pull',
  cardigan: 'Cardigan',
  gilet: 'Gilet',
  poncho: 'Poncho',
  cape: 'Cape',
  blazer: 'Blazer',
  perfecto: 'Perfecto',
  kimono: 'Kimono',
  trench: 'Trench',
  parka: 'Parka',
  doudoune: 'Doudoune',
  manteau: 'Manteau',
  caban: 'Caban',
  legging: 'Legging',
  tregging: 'Tregging',
  jogging: 'Jogging',
  chino: 'Chino',
  cargo: 'Cargo',
  bermuda: 'Bermuda',
  bikini: 'Bikini',
  tankini: 'Tankini',
  monokini: 'Monokini',
  escarpins: 'Escarpins',
  bottines: 'Bottines',
  cuissardes: 'Cuissardes',
  mocassins: 'Mocassins',
  derbies: 'Derbies',
  loafers: 'Loafers',
  sabots: 'Sabots',
  tongs: 'Tongs',
  claquettes: 'Claquettes',
  espadrilles: 'Espadrilles',
  cabas: 'Cabas',
  besace: 'Besace',
  sacoche: 'Sacoche',
  clutch: 'Clutch',
  minaudiere: 'Minaudière',
  valise: 'Valise',
  trousse: 'Trousse',
  portefeuille: 'Portefeuille',
  collier: 'Collier',
  sautoir: 'Sautoir',
  pendentif: 'Pendentif',
  bracelet: 'Bracelet',
  bague: 'Bague',
  broche: 'Broche',
  parure: 'Parure',
  echarpe: 'Écharpe',
  foulard: 'Foulard',
  snood: 'Snood',
  chapeau: 'Chapeau',
  casquette: 'Casquette',
  bonnet: 'Bonnet',
  bob: 'Bob',
  beret: 'Béret',
  bandeau: 'Bandeau',
  montre: 'Montre',
  mitaines: 'Mitaines',
  pyjama: 'Pyjama',
  running: 'Running',
  training: 'Training',
  basketball: 'Basketball',
  richelieu: 'Richelieu',
  smoking: 'Smoking',
  mallette: 'Mallette',
  bretelles: 'Bretelles',
  bougie: 'Bougie',
  vase: 'Vase',
  miroir: 'Miroir',
  coussin: 'Coussin',
  plaid: 'Plaid',
  mug: 'Mug',
  plateau: 'Plateau',
  manga: 'Manga',
  comics: 'Comics',
  atlas: 'Atlas',
  diy: 'DIY',
  yoga: 'Yoga',
  // Jouets & Jeux
  jeux: 'Jeux',
  jouets: 'Jouets',
  'jeux-exterieur': "Jeux d'extérieur",
  'loisirs-creatifs': 'Loisirs créatifs',
  electronique: 'Électronique',
  // Fournitures scolaires
  fournitures: 'Fournitures',
  'sacs-ecole': "Sacs d'école",
  accessoires: 'Accessoires',
  // Appareils bébé
  poussettes: 'Poussettes',
  'siege-auto': 'Sièges auto',
  portage: 'Portage',
  repas: 'Repas',
  bain: 'Bain',
  securite: 'Sécurité',
  'sante-soin': 'Santé & Soins',
  // Tenues religieuses & du monde — femme
  abaya: 'Abaya',
  niqab: 'Niqab',
  hijab: 'Hijab',
  djellaba: 'Djellaba',
  kaftan: 'Kaftan',
  caftan: 'Caftan',
  jilbab: 'Jilbab',
  khimar: 'Khimar',
  'ample-dress': 'Robe ample',
  sari: 'Sari',
  lehenga: 'Lehenga',
  'salwar-kameez': 'Salwar kameez',
  wax: 'Wax / pagne',
  boubou: 'Boubou',
  dashiki: 'Dashiki',
  hanbok: 'Hanbok',
  'ao-dai': 'Ao dai',
  'kimono-ceremonie': 'Kimono de cérémonie',
  'robe-traditionnelle': 'Robe traditionnelle',
  // Tenues religieuses — homme
  'djellaba-homme': 'Djellaba homme',
  'kaftan-homme': 'Kaftan homme',
  'boubou-homme': 'Boubou homme',
  qamis: 'Qamis',
  thobe: 'Thobe',
  'dashiki-homme': 'Dashiki homme',
  'tenue-traditionnelle-homme': 'Tenue traditionnelle',
  fitness: 'Fitness',
  natation: 'Natation',
  randonnee: 'Randonnée',
  ski: 'Ski',
  velo: 'Vélo',
  equipement: 'Équipement',
  // Livres — groupes & items manquants
  magazines: 'Magazines & Revues',
  roman: 'Roman',
  polar: 'Polar',
  thriller: 'Thriller',
  'science-fiction': 'Science-fiction',
  fantasy: 'Fantasy',
  romance: 'Romance',
  historique: 'Historique',
  classique: 'Classique',
  contemporain: 'Contemporain',
  nouvelle: 'Nouvelle',
  'roman-jeunesse': 'Roman jeunesse',
  'polar-jeunesse': 'Polar jeunesse',
  'graphic-novel': 'Graphic novel',
  autobiographie: 'Autobiographie',
  memoires: 'Mémoires',
  temoignage: 'Témoignage',
  // Crafts — groupes
  couture: 'Couture',
  crochet: 'Crochet',
  tricot: 'Tricot',
  broderie: 'Broderie',
  scrapbooking: 'Scrapbooking',
  peinture: 'Peinture',
  dessin: 'Dessin',
  poterie: 'Poterie',
  macrame: 'Macramé',
  enfant: 'Enfant',
  modelage: 'Modelage',
  perles: 'Perles',
  kits: 'Kits créatifs',
  coloriage: 'Coloriage',
  // Handmade — groupes
  vetements: 'Vêtements',
  peluches: 'Peluches',
  bebe: 'Bébé',
  // Custom — groupes
  cadeaux: 'Cadeaux',
  // Shoes — items manquants
  compensees: 'Compensées',
  'mules-talons': 'Mules à talons',
  'mules-plates': 'Mules plates',
  'sandales-talons': 'Sandales à talons',
  'sandales-plates': 'Sandales plates',
  'nu-pieds': 'Nu-pieds',
  babies: 'Babies',
  'baskets-basses': 'Baskets basses',
  'baskets-montantes': 'Baskets montantes',
  'sneakers-running': 'Sneakers running',
  'sneakers-lifestyle': 'Sneakers lifestyle',
  'bottines-chelsea': 'Bottines Chelsea',
  'bottines-western': 'Bottines western',
  'bottes-hautes': 'Bottes hautes',
  'bottes-cavalieres': 'Bottes cavalières',
  'bottes-pluie': 'Bottes de pluie',
  'bottes-neige': 'Bottes de neige',
  // Combinaisons & salopettes — items existants en data sans label explicite
  'combinaison-pantalon': 'Combinaison pantalon',
  'combinaison-short': 'Combinaison short',
  'combinaison-pilote': 'Combinaison pilote',
  'combinaison-ski': 'Combinaison ski',
  'combi-pilote': 'Combi pilote',
  salopette: 'Salopette',
  'salopette-jean': 'Salopette jean',
  'salopette-short': 'Salopette short',
  'salopette-bebe': 'Salopette bébé',
};

export const formatCategoryLabel = (key: string): string => {
  if (SPECIAL_LABELS[key]) return SPECIAL_LABELS[key];
  return key.replace(/-/g, ' ').replace(/\b\w/, c => c.toUpperCase());
};
